import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { FaFileExcel, FaFilePdf } from "react-icons/fa";
import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from "recharts";


const PurchaseReport = ({clientData}) => {
  const [selectedDate, setSelectedDate] = useState("");
const [purchaseHistory, setPurchaseHistory] = useState([]);
const [purchaseReturnHistory, setPurchaseReturnHistory] = useState([]);
  const [purchaseData, setPurchaseData] = useState([]);
  const [purchaseReturnData, setPurchaseReturnData] = useState([]);
const [fromDate, setFromDate] = useState("");
const [toDate, setToDate] = useState("");
  const client_id = localStorage.getItem("client_id");
useEffect(() => {
  fetchPurchaseHistory();
}, []);
const handleRowClick = (date) => {
  const key = new Date(date).toISOString().split("T")[0];

  setSelectedDate(key);

  setPurchaseHistory(
    purchaseData.filter(
      (item) => new Date(item.date).toISOString().split("T")[0] === key
    )
  );

  setPurchaseReturnHistory(
    purchaseReturnData.filter(
      (item) => new Date(item.date).toISOString().split("T")[0] === key
    )
  );
};


const fetchPurchaseHistory = async () => {
  try {
    const [purchaseRes, returnRes] = await Promise.all([
      axios.get(`https://api.dectwinbilling.com/fetch-purchase-bill/${client_id}`),
      axios.get(`https://api.dectwinbilling.com/fetch-purchase-return-bill/${client_id}`)
    ]);
    


    setPurchaseData(purchaseRes.data || []);
    setPurchaseReturnData(returnRes.data || []);
  } catch (err) {
    console.log(err);
  }
};

const exportToExcel = async () => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Purchase Report");

  worksheet.addRow(["PURCHASE REPORT"]);
  worksheet.mergeCells("A1:C1");

  const title = worksheet.getCell("A1");
  title.font = {
    bold: true,
    size: 18,
    color: { argb: "FFFFFF" },
  };
  title.fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "1F4E78" },
  };
  title.alignment = { horizontal: "center" };

  worksheet.addRow([]);
  worksheet.addRow(["From Date", fromDate || "All"]);
  worksheet.addRow(["To Date", toDate || "All"]);
  worksheet.addRow(["Generated On", new Date().toLocaleString()]);
  worksheet.addRow([]);
worksheet.addRow([
  "Type",
  "Invoice No",
  "Date",
  "Supplier",
  "Payment Method",
  "Total",
  "Received",
  "Due",
]);
  const header = worksheet.getRow(7);
  header.font = {
    bold: true,
    color: { argb: "FFFFFF" },
  };
  header.fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "4472C4" },
  };

//   chartData.forEach((item) => {
//     worksheet.addRow([
//       item.date,
//     item.purchaseCount,
// Number(item.purchaseTotal).toFixed(2),
//     ]);
//   });
combinedData.forEach((item) => {
  worksheet.addRow([
    item.type,
    item.invoiceNo,
    item.date,
    item.name,
    item.payment_method,
    Number(item.payable || 0).toFixed(2),
    Number(item.received || 0).toFixed(2),
    Number(item.due || 0).toFixed(2),
  ]);
});
  worksheet.addRow([]);
worksheet.addRow([]);

worksheet.addRow([
  "Total Purchase",
  "",
  "",
  "",
  "",
  totalPurchase.toFixed(2),
]);

worksheet.addRow([
  "Total Purchase Return",
  "",
  "",
  "",
  "",
  totalPurchaseReturn.toFixed(2),
]);

worksheet.addRow([
  "Net Purchase",
  "",
  "",
  "",
  "",
  netPurchase.toFixed(2),
]);

worksheet.addRow([
  "Total Entries",
  combinedData.length,
]);
  // worksheet.addRow(["Total Purchase", "", totalPurchase.toFixed(2)]);
  // worksheet.addRow(["Total Entries", purchaseData.length]);

  // worksheet.columns = [
  //   { width: 20 },
  //   { width: 20 },
  //   { width: 25 },
  // ];
  worksheet.columns = [
  { width: 18 }, 
  { width: 20 }, 
  { width: 15 }, 
  { width: 30 }, 
  { width: 25 }, 
  { width: 18 }, 
  { width: 18 }, 
  { width: 18 },
];

  worksheet.eachRow((row) => {
    row.eachCell((cell) => {
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });
  });

  const buffer = await workbook.xlsx.writeBuffer();

  saveAs(
    new Blob([buffer]),
    `Purchase_Report_${new Date().getTime()}.xlsx`
  );
};
  


const chartData = useMemo(() => {
  const grouped = {};

  const getDate = (value) => {
    return new Date(value).toISOString().split("T")[0]; 
  };

  
  purchaseData.forEach((item) => {
    const key = getDate(item.date);

    if (!grouped[key]) {
      grouped[key] = {
        date: key,
        purchaseHistory: [],
        purchaseReturnHistory: [],
        purchaseCount: 0,
        returnCount: 0,
        purchaseTotal: 0,
        returnTotal: 0,
      };
    }

    grouped[key].purchaseHistory.push(item);
    grouped[key].purchaseCount++;
    grouped[key].purchaseTotal += Number(item.payable || 0);
  });

  
  purchaseReturnData.forEach((item) => {
    const key = getDate(item.date);

    if (!grouped[key]) {
      grouped[key] = {
        date: key,
        purchaseHistory: [],
        purchaseReturnHistory: [],
        purchaseCount: 0,
        returnCount: 0,
        purchaseTotal: 0,
        returnTotal: 0,
      };
    }

    grouped[key].purchaseReturnHistory.push(item);
    grouped[key].returnCount++;
    grouped[key].returnTotal += Number(item.payable || 0);
  });

  return Object.values(grouped).map((item) => ({
    ...item,
    count: item.purchaseCount + item.returnCount,
    total: item.purchaseTotal + item.returnTotal,
  }));
}, [purchaseData, purchaseReturnData]);
const totalPurchase = chartData.reduce(
  (sum, item) => sum + item.purchaseTotal,
  0
);

const totalPurchaseReturn = chartData.reduce(
  (sum, item) => sum + item.returnTotal,
  0
);

const netPurchase = totalPurchase - totalPurchaseReturn;
const combinedData = useMemo(() => {
  const purchase = purchaseData.map((item) => ({
    ...item,
    type: "Purchase",
  }));

  const purchaseReturn = purchaseReturnData.map((item) => ({
    ...item,
    type: "Purchase Return",
  }));

  return [...purchase, ...purchaseReturn].sort(
    (a, b) => new Date(a.date) - new Date(b.date)
  );
}, [purchaseData, purchaseReturnData]);


  const exportToPDF = () => {
  const doc = new jsPDF();

  doc.setFontSize(18);
  doc.text("Purchase Report", 14, 18);

  doc.setFontSize(11);
  doc.text(`From Date : ${fromDate || "All"}`, 14, 28);
  doc.text(`To Date : ${toDate || "All"}`, 14, 35);
  doc.text(
    `Generated On : ${new Date().toLocaleString()}`,
    14,
    42
  );

  autoTable(doc, {
    startY: 50,
    head: [["Date", "Purchase Count", "Total Purchase"]],
    body: chartData.map((item) => [
      item.date,
   item.purchaseCount,
`Rs. ${Number(item.purchaseTotal).toFixed(2)}`
    ]),
    theme: "grid",
    headStyles: {
      fillColor: [68, 114, 196],
    },
  });

  const finalY = doc.lastAutoTable.finalY + 10;

doc.text(
  `Total Purchase : Rs. ${totalPurchase.toFixed(2)}`,
  14,
  finalY
);

  doc.text(
    `Total Entries : ${purchaseData.length}`,
    14,
    finalY + 8
  );

  doc.save("Purchase_Report.pdf");
};
  

  return (
    <div className="container-fluid mt-3">
      <div className="row mb-3">

  <div className="col-6 col-md-6">
    <label className="form-label fw-bold">From Date</label>
    <input
      type="date"
      className="form-control w-100 w-md-50"
      style={{ maxWidth: "220px" }}
      value={fromDate}
      onChange={(e) => setFromDate(e.target.value)}
    />
  </div>

  <div className="col-6 col-md-6 d-flex flex-column align-items-md-end">
    <label className="form-label fw-bold">To Date</label>
    <input
      type="date"
      className="form-control w-100"
      style={{ maxWidth: "220px" }}
      value={toDate}
      onChange={(e) => setToDate(e.target.value)}
    />
  </div>

</div>
<div className="row g-3">



<div className="col-12 col-lg-8">

  <div
    className="card border-0 shadow-lg"
    style={{ borderRadius: "18px" }}
  >

  

    
    <div className="card-body">

      {/* <h4>Purchase Report</h4>
      <div className="row g-3 mb-4">

        <div className="col-md-6">
          <div
            className="p-3 rounded-3 shadow-sm"
            style={{
              background: "#EEF4FF",
            }}
          >
            <small className="text-muted">
              Total Purchase
            </small>

            <h4 className="fw-bold text-primary mb-0">
              ₹{totalPurchase.toFixed(2)}
            </h4>

            
          </div>
        </div>
        

        <div className="col-md-6">
          <div
            className="p-3 rounded-3 shadow-sm"
            style={{
              background: "#F4FFF4",
            }}
          >
            <small className="text-muted">
              Purchase Entries
            </small>

            <h4 className="fw-bold text-success mb-0">
              {purchaseData.length}
            </h4>
          </div>
        </div>

      </div> */}
<div className="row g-3 mb-4">

  {/* Total Purchase */}
  <div className="col-12 col-md-4">
    <div
      className="p-3 rounded-3 shadow-sm h-100 text-center"
      style={{ background: "#EEF4FF" }}
    >
      <small className="text-muted">Total Purchase</small>
      <h3 className="fw-bold text-primary mt-2">
        ₹{totalPurchase.toFixed(2)}
      </h3>
    </div>
  </div>

  {/* Purchase Return */}
  <div className="col-12 col-md-4">
    <div
      className="p-3 rounded-3 shadow-sm h-100 text-center"
      style={{ background: "#FFF4E6" }}
    >
      <small className="text-muted">Purchase Return</small>
      <h3 className="fw-bold text-warning mt-2">
        ₹{totalPurchaseReturn.toFixed(2)}
      </h3>
    </div>
  </div>

  {/* Net Purchase */}
  <div className="col-12 col-md-4">
    <div
      className="p-3 rounded-3 shadow-sm h-100 text-center"
      style={{ background: "#F4FFF4" }}
    >
      <small className="text-muted">Net Purchase</small>
      <h3 className="fw-bold text-success mt-2">
        ₹{netPurchase.toFixed(2)}
      </h3>
    </div>
  </div>

</div>
      
      <div
        className="p-3 rounded-4"
        style={{
          height: "430px",
          background: "#fff",
          border: "1px solid #ececec",
        }}
      >
        <ResponsiveContainer width="100%" height="100%">

          <LineChart
            data={chartData}
            margin={{
              top: 20,
              right: 30,
              left: 10,
              bottom: 10,
            }}
          >

            <CartesianGrid
              strokeDasharray="4 4"
              stroke="#e5e7eb"
            />

            <XAxis
              dataKey="date"
              tick={{ fontSize: 12 }}
            />

            <YAxis
              tick={{ fontSize: 12 }}
            />

            <Tooltip
              contentStyle={{
                borderRadius: "10px",
                border: "none",
                boxShadow: "0 4px 15px rgba(0,0,0,.15)",
              }}
            />

            <Line
              type="monotone"
            dataKey="purchaseTotal"
              stroke="#4F46E5"
              strokeWidth={4}
              dot={{
                r: 5,
                fill: "#4F46E5",
              }}
              activeDot={{
                r: 8,
              }}
            />

          </LineChart>

        </ResponsiveContainer>
      </div>

    </div>

  </div>

</div>


  <div className="col-12 col-md-4">

    <div className="card shadow h-100">

    <div
  className="table-responsive shadow-sm"
  style={{
    maxHeight: "500px",
    overflowY: "auto",
    borderRadius: "15px",
    border: "1px solid #e9ecef",
    background: "#fff",
  }}
>
        <table className="table table-bordered table-hover text-center mb-0">

          <thead
  className="sticky-top"
  style={{
    background: "linear-gradient(90deg,#4f46e5,#7c3aed)",
    color: "#fff",
  }}
>
  <tr>
    <th className="py-3"> Date</th>
    <th className="py-3"> Purchase Count</th>
    <th className="py-3"> Total</th>
  </tr>
</thead>

      

          {/* <tbody>
  {chartData.length ? (
    chartData.map((item, index) => (
      // <tr key={index}>
      <tr
   key={index}
   style={{ cursor: "pointer" }}
   data-bs-toggle="modal"
   data-bs-target="#purchaseModal"
   onClick={() => handleRowClick(item.date)}
>
        <td className="fw-semibold">{item.date}</td>

        <td>
          <span className=" px-3 py-2">
        {item.purchaseCount}
          </span>
        </td>

        <td className="fw-bold text-success">
       ₹{item.purchaseTotal.toFixed(2)}
        </td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="3" className="py-5 text-muted">
        No Purchase Found
      </td>
    </tr>
  )}
</tbody> */}
<tbody>
  {chartData.map((item, index) => (
    <tr
      key={index}
      style={{ cursor: "pointer" }}
      data-bs-toggle="modal"
      data-bs-target="#purchaseModal"
      onClick={() => handleRowClick(item.date)}
    >
      <td>{item.date}</td>

      <td>{item.count}</td>

      <td>₹{item.total.toFixed(2)}</td>
    </tr>
  ))}
</tbody>

        </table>
      </div>

    </div>

  </div>
<div className="d-flex justify-content-end gap-3 mt-3 flex-wrap">


  <button
    className="btn d-flex align-items-center gap-2 px-4 py-2 shadow"
    onClick={exportToExcel}
    style={{
      background: "linear-gradient(135deg, #28a745, #198754)",
      color: "#fff",
      border: "none",
      borderRadius: "10px",
      fontWeight: "600",
      transition: "0.3s ease",
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = "translateY(-2px)";
      e.currentTarget.style.boxShadow =
        "0 8px 20px rgba(25,135,84,0.35)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = "translateY(0)";
      e.currentTarget.style.boxShadow = "";
    }}
  >
    <FaFileExcel size={20} />
    Excel
  </button>

  
  <button
    className="btn d-flex align-items-center gap-2 px-4 py-2 shadow"
    onClick={exportToPDF}
    style={{
      background: "linear-gradient(135deg, #dc3545, #b02a37)",
      color: "#fff",
      border: "none",
      borderRadius: "10px",
      fontWeight: "600",
      transition: "0.3s ease",
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = "translateY(-2px)";
      e.currentTarget.style.boxShadow =
        "0 8px 20px rgba(220,53,69,0.35)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = "translateY(0)";
      e.currentTarget.style.boxShadow = "";
    }}
  >
    <FaFilePdf size={20} />
    PDF
  </button>
  

</div>
<div
  className="modal fade"
  id="purchaseModal"
  tabIndex="-1"
>
<div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
    <div className="modal-content">

      <div className="modal-header">
        <h5>{selectedDate}</h5>

        <button
          className="btn-close"
          data-bs-dismiss="modal"
        ></button>
      </div>

      <div className="modal-body">

        <h5>Purchase History</h5>
<div className="table-responsive">
  <table className="table table-bordered table-hover align-middle">
          <thead>
            <tr>
              <th>Invoice</th>
              <th>Payment mode</th>
               <th>Name</th>
              <th>Date</th>
              <th>Total</th>
              <th>Received</th>
              <th>Due</th>
            </tr>
          </thead>

          <tbody>
            {purchaseHistory.map((item) => (
              <tr key={item.id}>
                <td>{item.invoiceNo}</td>
                   <td>{item.payment_method}</td>
                <td>{item.name}</td>
                   <td>{item.date}</td>
                <td>{item.payable}</td>
                   <td>{item.received}</td>
                      <td>{item.due}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <hr />

        <h5>Purchase Return History</h5>

       <div className="table-responsive">
  <table className="table table-bordered table-hover align-middle">
          <thead>
            <tr>
              <th>Invoice</th>
              <th>Payment method</th>
               <th>Name</th>
              <th>Date</th>
              <th>Total</th>
              <th>Received</th>
              <th>Due</th>
            </tr>
          </thead>

          <tbody>
            {purchaseReturnHistory.map((item) => (
              <tr key={item.id}>
                  <td>{item.invoiceNo}</td>
                   <td>{item.payment_method}</td>
                <td>{item.name}</td>
                  <td>{item.date}</td>
                <td>{item.payable}</td>
              </tr>
            ))}
          </tbody>
        </table>

      </div>
      </div>

    </div>
  </div>
</div>

</div>
</div>

    </div>
    
  );
};

export default PurchaseReport;